export const DEP_YATIVERSE = '/yativerse';
